"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const UiIcon = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_core_1.Icon, { size: props.size ? props.size : 'md', status: props.status, className: props.className }, props.icon)));
};
exports.default = UiIcon;
//# sourceMappingURL=UiIcon.js.map